import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MpIcon(props: IconProps) {
    return <Icon {...props} iconKey={"mp"}/>
}
